import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Css, Responsive } from '@/ui';
import JobTypeBadge from '../../job/JobTypeBadge';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';

interface IJobTypeProps {
	type: string;
}

const styles = css`
	display: flex;
	min-width: fit-content;
	padding-right: ${Css.pxToRem(18)};
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	padding-top: 0;
	padding-bottom: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-right: 0;
	}
`;

export function Header() {
	return <StyledHeader css={styles}>Job Type</StyledHeader>;
}

export function Cell({ type }: IJobTypeProps) {
	return (
		<StyledCell css={styles}>
			<JobTypeBadge type={type} />
		</StyledCell>
	);
}
